const ROUTE_LABELS: Array<{ pattern: RegExp; label: string }> = [
  { pattern: /^\/projects\/[^/]+\/loops\/[^/]+\/edit$/, label: 'Edit Loop' },
  { pattern: /^\/projects\/[^/]+\/loops\/new$/, label: 'New Loop' },
  { pattern: /^\/projects\/[^/]+\/issues\/new$/, label: 'New Issue' },
  { pattern: /^\/prototypes\/[^/]+\/issues\/new$/, label: 'New Issue' },
  { pattern: /^\/projects\/[^/]+\/loops$/, label: 'Loops' },
  { pattern: /^\/issues\/[^/]+\/edit$/, label: 'Edit Issue' },
  { pattern: /^\/issues\/[^/]+$/, label: 'Issue Detail' },
  { pattern: /^\/projects\/[^/]+$/, label: 'Project' },
  { pattern: /^\/prototypes\/[^/]+$/, label: 'Prototype Detail' },
  { pattern: /^\/runs\/[^/]+$/, label: 'Run Detail' },
  { pattern: /^\/$/, label: 'Overview' },
  { pattern: /^\/projects$/, label: 'Projects' },
  { pattern: /^\/prototypes$/, label: 'Prototypes' },
  { pattern: /^\/activity$/, label: 'Activity' },
  { pattern: /^\/metrics$/, label: 'Metrics' },
  { pattern: /^\/settings$/, label: 'Settings' },
  { pattern: /^\/docs$/, label: 'Docs' },
  { pattern: /^\/login$/, label: 'Login' },
  { pattern: /^\/security\/enroll$/, label: 'Enroll 2FA' },
];

export function labelForPath(path: string): string {
  for (const { pattern, label } of ROUTE_LABELS) {
    if (pattern.test(path)) return label;
  }
  return path;
}
